var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import DataTable from '@/components/data-table/DataTable';
import { SubjectLabelCategory as SubjectLabelCategoryModel } from '@/models/SubjectLabelCategory';
import AddSubjectLabelCategoryDialog from '@/views/SubjectLabelCategories/AddSubjectLabelCategoryDialog';
import AddSubjectLabelDialog from '@/views/SubjectLabels/AddSubjectLabelDialog';
import ErrorHandler from '@/support/ErrorHandler';
import LabelValue from '@/components/LabelValue.vue';
import { SubjectLabel } from '@/models/SubjectLabel';
let SubjectLabelCategory = class SubjectLabelCategory extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.subjectLabelCategoryId = this.$route.params.id;
        this.subjectLabelCategory = null;
        this.isLoading = true;
        this.isEditingTagCategory = false;
        this.isCreatingOrUpdatingSubjectLabel = false;
        this.selectedSubjectLabel = null;
        this.selectedSubjectLabels = [];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        this.isEditingTagCategory = false;
        await this.fetchSubjectLabelCategory();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    refreshFilterStore() {
        new SubjectLabel()
            .all()
            .then((subjectLabels) => {
            const mutatedSubjectLabels = [];
            const payload = {};
            subjectLabels.forEach((subjectLabel) => {
                mutatedSubjectLabels.push({
                    value: subjectLabel.id,
                    text: subjectLabel.getFilterLabel(),
                });
            });
            payload.SubjectLabel = mutatedSubjectLabels;
            this.$store.dispatch('updateFilters', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refreshDataTable() {
        this.isCreatingOrUpdatingSubjectLabel = false;
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    onEditTagCategory() {
        this.isEditingTagCategory = true;
    }
    onCreateTag() {
        this.isCreatingOrUpdatingSubjectLabel = true;
    }
    onSelectionChanged(selected) {
        this.selectedSubjectLabels = selected;
    }
    onDeleteSelected() {
        this.$store.dispatch('openDialog', this.bulkDeleteDialogOptions);
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchSubjectLabelCategory() {
        try {
            this.subjectLabelCategory = await new SubjectLabelCategoryModel().include('subjects').find(this.subjectLabelCategoryId);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get pageTitle() {
        if (!this.subjectLabelCategory || !this.subjectLabelCategory.label) {
            return this.$tc('Subject label category');
        }
        return this.subjectLabelCategory.label;
    }
    get pageDescription() {
        if (!this.subjectLabelCategory || !this.subjectLabelCategory.subjects || !this.subjectLabelCategory.subjects.length) {
            return '';
        }
        return this.subjectLabelCategory.subjects
            .map((subjectLabel) => {
            return subjectLabel.name;
        })
            .join(', ');
    }
    get breadcrumbs() {
        let secondCrumb = this.subjectLabelCategory && this.subjectLabelCategory.label ? this.subjectLabelCategory.label : '-';
        if (secondCrumb === 'Algemeen') {
            secondCrumb = this.$tc('General');
        }
        return [{ name: this.$tc('Tag categories'), path: '/subject-label-categories' }, { name: secondCrumb }];
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('subject_label.title', 1),
                plural: this.$tc('subject_label.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'label',
                    editable: false,
                    changed: false,
                },
                {
                    text: this.$t('Tag category'),
                    slot: 'tag_category',
                    value: 'tag_category',
                    editable: false,
                    changed: false,
                },
            ],
            actions: [
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    action: (vm, subjectLabel) => {
                        this.selectedSubjectLabel = subjectLabel;
                        this.isCreatingOrUpdatingSubjectLabel = true;
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, subjectLabel) => {
                        this.selectedSubjectLabel = subjectLabel;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            model: new SubjectLabel().include('subject_labels').filter('tag_category_id', this.subjectLabelCategoryId),
        };
    }
    get dialogOptions() {
        const subjectLabel = this.selectedSubjectLabel;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: subjectLabel.name }),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!subjectLabel) {
                            return;
                        }
                        subjectLabel
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedSubjectLabel = null;
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedSubjectLabel = null;
                    },
                },
            },
        };
    }
    get bulkDeleteDialogOptions() {
        const count = this.selectedSubjectLabels.length;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', count, { item: `${count} ${this.$tc('subject_label.title', count)}` }),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        this.isLoading = true;
                        const deletePromises = this.selectedSubjectLabels.map((subjectLabel) => subjectLabel.delete());
                        Promise.all(deletePromises)
                            .then(() => {
                            this.selectedSubjectLabels = [];
                            this.refreshDataTable();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        })
                            .finally(() => {
                            this.isLoading = false;
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => { },
                },
            },
        };
    }
    get isDefaultCategory() {
        return !!this.subjectLabelCategory && this.subjectLabelCategory.label === 'Algemeen';
    }
};
SubjectLabelCategory = __decorate([
    Component({
        components: {
            PageHeader,
            DataTable,
            AddSubjectLabelCategoryDialog,
            LabelValue,
            AddSubjectLabelDialog,
        },
    })
], SubjectLabelCategory);
export default SubjectLabelCategory;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
